import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

interface MobileSliderProps {
  children: React.ReactNode;
}

const MobileSlider: React.FC< MobileSliderProps> = ({ children  }) =>  {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = React.Children.count(children);

  return (
    <div className="container p-0">
      <Swiper
        modules={[Autoplay]}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
      >
        {React.Children.map(children, (child, idx) => (
          <SwiperSlide key={idx}>
            <div className="w-full">{child}</div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Dots (Progress Indicators) */}
      <div className="flex justify-center items-center gap-2 px-[24px] pt-[32px] py-[24px] bg-transparent mt-[0] max-w-[244px] mx-auto">
        {Array.from({ length: totalSlides }).map((_, idx) => (
          <button
            aria-label="dot"
            key={idx}
            onClick={() => {
              // manually move to slide
              const swiperEl = document.querySelector(".swiper") as any;
              if (swiperEl && swiperEl.swiper) swiperEl.swiper.slideToLoop(idx);
            }}
            className={`p-0 relative overflow-hidden transition-all ${
              currentSlide === idx
                ? "flex-1 min-w-[60px] w-16 h-1 bg-[#fff]"
                : "flex-none w-4 h-1 bg-[#fff]"
            }`}
          >
            <span
              className={`absolute top-0 left-0 w-full h-1 ${
                currentSlide === idx
                  ? "bg-gradient-to-r from-[#8ABC00] to-[#0086E6] transition-all duration-[4000ms]"
                  : "left-[-100%]"
              }`}
            ></span>
          </button>
        ))}
      </div>
    </div>
  );
};
export default MobileSlider;
